module.exports = __webpack_public_path__ + "img/logo-BNB-tmp.6957e848.svg";